import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivityPerformerSlot } from "../../../models/activity/activity-performer-slot";

@Component({
    selector: 'activity-performer-slots-confirmation',
    templateUrl: './activity-performer-slots-confirmation.component.html',
    styleUrls: ['./activity-performer-slots-confirmation.component.scss',]
})
export class ActivityPerformerSlotsConfirmationComponent {

    @Input() activityPerformerSlots: ActivityPerformerSlot[] = [];

    @Output() onContinueEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() onCancelEvent: EventEmitter<any> = new EventEmitter<any>();

    continue() {
        this.onContinueEvent.emit();
    }

    cancel() {
        this.onCancelEvent.emit();
    }
}